<template>
  <div class="height1 inventory-page">
    <bread></bread>
    <div class="center-content">
      <div class="iq-card-body inventory-card">
        <div class="table-top">
          <div class="iq-search-bar">
            <el-form class="inventory-filters" :model="searchForm" :inline="true">
              <el-form-item label="药品分类">
                <el-select
                  v-model="searchForm.categoryId"
                  placeholder="请选择"
                  size="small"
                  style="width: 120px"
                  @change="Search"
                >
                  <el-option
                    :label="item.categoryName"
                    :value="item.categoryId"
                    v-for="(item, index) in categoryData"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否含空库存">
                <el-radio-group v-model="searchForm.isEmpty" @change="Search()">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item>
                <el-date-picker
                  v-model="searchForm.datepicker"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions0"
                  size="small"
                  style="width: 260px"
                  clearable
                  @change="Search"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="批号" class="inventory-batch">
                <el-input
                  v-model="searchForm.batchNumber"
                  type="text"
                  size="small"
                  placeholder="批号"
                  @keyup.enter.native="Search"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item class="inventory-keyword">
                <el-input
                  v-model="searchForm.keyWord"
                  type="text"
                  size="small"
                  placeholder="药品名称/别名/商品名称"
                  @keyup.enter.native="Search"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="Search()"
                  >搜索</el-button
                >
              </el-form-item>
            </el-form>
          </div>
          <div class="inventory-actions">
            <el-button type="primary" size="small" @click="addDrug()" plain
              >药品入库</el-button>
            <div class="inventory-file-actions">
              <el-button type="warning" size="mini" class="el-icon-download" @click="downloadTemplate"
                >下载模板</el-button>
              <el-upload
                class="inventory-import"
                :show-file-list="false"
                accept=".xlsx,.xls"
                :auto-upload="true"
                :headers="headers"
                :action="fileUploadUrl"
                :on-success="uploadSuccess"
              >
                <el-button size="mini" type="success" class="el-icon-upload2"
                  >批量导入</el-button>
              </el-upload>
              <el-button
                type="warning"
                size="mini"
                icon="el-icon-download"
                :loading="exportLoading"
                :disabled="exportLoading || !tableData.length"
                @click="exportInventory"
              >导出数据</el-button>
            </div>
          </div>
        </div>
        <div class="inventory-table-wrap">
        <el-table
          :data="tableData"
          stripe
          style="width: 100%"
          :header-cell-style="{ background: '#F5F7FC' }"
          height="100%"
        >
          <el-table-column
            type="index"
            label="编号"
            width="50"
          ></el-table-column>
          <el-table-column prop="mzDrugOrg.mzDrug.drugName" label="药品名称">
            <template slot-scope="scope">
              {{ scope.row.mzDrugOrg.mzDrug.drugName }}
              <span v-if="scope.row.mzDrugOrg.mzDrug.drugType == 'T'"
                >(统)</span
              >
              <span v-if="scope.row.mzDrugOrg.mzDrug.drugType == 'X'"
                >(选)</span
              >
              <span v-if="scope.row.mzDrugOrg.mzDrug.drugType == 'J'"
                >(精选)</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="mzDrugOrg.mzDrug.drugAlias"
            label="别名"
            align="center"
          >
          </el-table-column>
          <!-- <el-table-column prop="mzDrugOrg.productName" label="商品名" align="center"> </el-table-column> -->
          <el-table-column
            prop="mzDrugOrg.mzDrug.category.categoryName"
            label="药品分类"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="mzDrugOrg.specification"
            label="规格"
            align="center"
          >
            <template slot-scope="scope">
              <p v-if="scope.row.mzDrugOrg.specification">
                {{ scope.row.mzDrugOrg.specification }}/{{
                  scope.row.mzDrugOrg.specificationUnit
                }}
              </p>
            </template>
          </el-table-column>
          <el-table-column
            prop="mzDrugOrg.productFactory"
            label="生产厂家"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <!-- <el-table-column prop="mzDrugOrg.supplier" label="供应商" align="center"></el-table-column> -->
          <el-table-column
            prop="batchNumber"
            label="批号"
            align="center"
          ></el-table-column>
          <el-table-column prop="putInPrice" label="进货价(元)" align="center">
            <template slot-scope="scope">
              {{ scope.row.putInPrice.toFixed(2) }}/{{
                scope.row.mzDrugOrg.specificationUnit
              }}
            </template>
          </el-table-column>
          <el-table-column prop="tradingPrice" label="售价(元)" align="center">
            <template slot-scope="scope">
              {{ scope.row.tradingPrice.toFixed(2) }}/{{
                scope.row.mzDrugOrg.isSeparate
                  ? scope.row.mzDrugOrg.separateNumberUnit
                  : scope.row.mzDrugOrg.specificationUnit
              }}
            </template>
          </el-table-column>
          <el-table-column prop="putInNumber" label="入库数量" align="center">
            <template slot-scope="scope">
              {{ scope.row.putInNumber }}（{{
                scope.row.mzDrugOrg.isSeparate
                  ? scope.row.mzDrugOrg.separateNumberUnit
                  : scope.row.mzDrugOrg.specificationUnit
              }}）
            </template>
          </el-table-column>
          <el-table-column
            prop="inventoryNumber"
            label="剩余库存"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.inventoryNumber }}（{{
                scope.row.mzDrugOrg.isSeparate
                  ? scope.row.mzDrugOrg.separateNumberUnit
                  : scope.row.mzDrugOrg.specificationUnit
              }}）
            </template>
          </el-table-column>
          <el-table-column
            prop="addTime"
            label="添加时间"
            align="center"
            width="150px"
            sortable
          >
            <template slot-scope="scope">
              <span>{{ scope.row.addTime | timefilters }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="validDate"
            label="药品有效期"
            align="center"
            width="190px"
            sortable
          >
            <template slot-scope="scope">
              <span v-if="scope.row.productionDate"
                >{{ scope.row.productionDate.split("T")[0] }} 至
              </span>
              <span>{{ scope.row.validDate.split("T")[0] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="追溯图片" align="center" width="120px">
            <template slot-scope="scope">
              <div
                v-if="scope.row.traceabilityImg"
                style="margin-bottom: 0; line-height: 0"
              >
                <el-image
                  style="width: 50px; height: 50px"
                  :src="scope.row.traceabilityImg"
                  :preview-src-list="[scope.row.traceabilityImg]"
                >
                </el-image>
              </div>
              <el-upload
                class="upload-demo"
                :action="fileUploadUrl"
                :headers="headers"
                :on-success="(res) => handleUploadSuccess(res, scope.row)"
                :before-upload="beforeUpload"
                :show-file-list="false"
              >
                <el-button
                  size="mini"
                  :type="scope.row.traceabilityImg ? 'text' : 'primary'"
                >
                  {{ scope.row.traceabilityImg ? "重新上传" : "上传" }}
                </el-button>
              </el-upload>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <span
                class="danger optionBtn"
                @click="returnBtn(scope.row)"
                v-if="scope.row.inventoryNumber > 0"
                >退库</span
              >
            </template>
          </el-table-column>
        </el-table>
        </div>
        <el-pagination
          class="inventory-pagination"
          @size-change="changePageSize"
          :page-sizes="[20, 30, 50, 100, 200, 300, 500]"
          @current-change="changePage"
          :page-size="pageSize"
          :current-page="pageIndex"
          :total="dataTotal"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="退库" :visible.sync="returnDialog" width="30%">
      <el-form
        class="dialog-form"
        :model="returnForm"
        ref="returnForm"
        :label-width="formLabelWidth"
        :rules="rules"
      >
        <el-form-item label="退库数量" prop="putOutNumber">
          <el-input-number
            v-model="returnForm.putOutNumber"
            size="small"
            controls-position="right"
            :precision="0"
            :step="1"
            :max="putOutNumber"
            :min="1"
            class="leftInput"
            style="width: 150px"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="退库原因" prop="putOut">
          <el-select
            v-model="returnForm.putOutReason"
            placeholder="请选择"
            clearable
            style="width: 100%"
          >
            <el-option
              :label="item.adviceContent"
              :value="item.adviceContent"
              v-for="item in returnReason"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="CloseDialog('returnForm')">取 消</el-button>
        <el-button type="primary" @click="saveData('returnForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Outpatient } from "@/components/DrugDomain/Outpatient";
export default {
  inject: ["reload"],
  computed: {
    headers() {
      return {
        Authorization:
          "Bearer" +
          " " +
          JSON.parse(sessionStorage.getItem(this.ClientId + "Token"))
            .access_token,
      };
    },
  },
  data() {
    var outpatient = new Outpatient(this.TokenClient, this.Services.Drug);
    return {
      OutpatientDomain: outpatient,
      // headers: { "Content-Type": "multipart/form-data;charset=UTF-8" },
      fileUploadUrl: this.CommonFilePath,
      tableData: [],
      categoryData: [],
      pageIndex: 1,
      dataTotal: 0,
      pageSize: 20,
      exportLoading: false,
      searchForm: {
        keyWord: "",
        batchNumber: "",
        categoryId: 0,
        isEmpty: true,
        datepicker: "",
      },
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      fileList: [],
      returnDialog: false,
      formLabelWidth: "90px",
      returnForm: {
        mzDrugInId: "",
        putOutNumber: null,
        putOutReason: "",
      },
      returnReason: [],
      putOutNumber: 0,
      rules: {
        putOutNumber: [
          { required: true, message: "请输入退库数量", trigger: "blur" },
        ],
        putOutReason: [
          { required: true, message: "请选择退库原因", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    this.getList();
    this.LoadCategory();
    this.getReturnReason();
  },
  methods: {
    downloadTemplate() {
      let a = document.createElement("a");
      a.href = "./OrgDrugWarehousingImp.xlsx";
      a.download = "药品入库模版.xlsx";
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    handleUploadSuccess(res, row) {
      if (res && res.length > 0) {
        this.$set(row, "traceabilityImg", res[0].fullUrl);

        // 调用保存接口持久化到数据库
        this.OutpatientDomain.UpdateDrugInTraceabilityImg(
          row.id,
          res[0].fullUrl,
          (data) => {
            this.$message.success("上传并保存成功");
          },
          (err) => {
            console.log(err);
            this.$message.error("保存图片路径失败");
          }
        );
      }
    },
    beforeUpload(file) {
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isLt20M) {
        this.$message.error("上传图片大小不能超过 20MB!");
      }
      return isLt20M;
    },
    uploadSuccess(res, file) {
      var _this = this;
      let filePath = `${res[0].fullUrl}`.trim();
      this.OutpatientDomain.ImportMZDrugOrgIn(
        filePath,
        function (data) {
          _this.$alert(data.data, "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              _this.pageIndex = 1;
              _this.getList();
            },
          });
        },
        function (err) {
          let jsonObj = JSON.parse(err.msg);
          // _this.$message({
          //   message: jsonObj.msg,
          //   type: 'error',
          // })
          _this.$alert(jsonObj.msg, "提示", {
            confirmButtonText: "确定",
            callback: (action) => {},
          });
        }
      );
    },
    getReturnReason() {
      var _this = this;
      _this.OutpatientDomain.RefundRepertoryList(
        "",
        1,
        function (data) {
          _this.returnReason = data.data.results;
        },
        function (err) {
          console.log(err);
        }
      );
    },
    saveData(formName) {
      var _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(_this.returnForm);
          const loading = this.$loading({
            lock: true,
            background: "rgba(0, 0, 0, 0.5)",
          });
          _this.OutpatientDomain.DrugOrgOut(
            _this.returnForm,
            function (data) {
              loading.close();
              _this.$message({
                message: "操作成功",
                type: "success",
              });
              _this.reload();
            },
            function (error) {
              loading.close();
              let jsonObj = JSON.parse(error.msg);
              _this.$message({
                message: jsonObj.msg,
                type: "error",
              });
              console.log(error);
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    CloseDialog(formName) {
      this.returnDialog = false;
      this.$refs[formName].resetFields();
    },
    returnBtn(row) {
      this.returnDialog = true;
      this.putOutNumber = row.inventoryNumber;
      this.returnForm = {
        mzDrugInId: row.id,
        putOutNumber: row.inventoryNumber,
        putOutReason: "",
      };
    },
    LoadCategory() {
      var _this = this;
      _this.OutpatientDomain.GetOutpatientCategories(
        function (data) {
          _this.categoryData = data.data.categories;
          _this.categoryData.unshift({ categoryId: 0, categoryName: "全部" });
        },
        function (err) {
          console.log(err);
        }
      );
    },
    addDrug() {
      this.$router.push("./DrugsWarehousing");
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.pageIndex = 1;
      this.getList();
    },
    changePage(pageIndex) {
      this.pageIndex = pageIndex;
      this.getList();
    },
    getList() {
      var _this = this;
      _this.tableData = [];
      var item = this.getSearchParams();
      _this.OutpatientDomain.DrugOrgInList(
        item.keyWord,
        item.batchNumber,
        item.categoryId,
        item.isEmpty,
        item.startTime,
        item.endTime,
        this.pageIndex,
        function (data) {
          _this.tableData = data.data.results;
          _this.pageIndex = data.data.pageIndex;
          _this.pageSize = data.data.pageSize;
          _this.dataTotal = data.data.dataTotal;
        },
        function (err) {
          console.log(err);
        },
        _this.pageSize
      );
    },
    Search(event) {
      this.pageIndex = 1;
      this.getList();
    },
    getSearchParams() {
      const item = this.searchForm;
      const dates = item.datepicker || [];
      return {
        keyWord: item.keyWord,
        batchNumber: item.batchNumber,
        categoryId: item.categoryId,
        isEmpty: item.isEmpty,
        startTime: dates[0] ? dates[0] + " 00:00:00" : "",
        endTime: dates[1] ? dates[1] + " 23:59:59" : "",
      };
    },
    // 导入数据
    handleExcel(file, fileList) {
      console.log(file.raw);
      let formData = new FormData(); //声明一个FormDate对象
      formData.append("formFile", file.raw); //把文件信息放入对象中
    },
    async exportInventory() {
      if (this.exportLoading) return [];
      if (!this.tableData.length) {
        this.$message.warning("当前页暂无可导出的库存数据");
        return [];
      }
      this.exportLoading = true;
      try {
        const data = this.tableData.map((row, index) => this.formatExportRow(row, index));
        const { exportXlsx } = await import("@/utils/exportXlsx");
        await exportXlsx(data, "库存管理");
        return data;
      } catch (err) {
        console.error(err);
        this.$message.error("库存导出失败，请重试");
        return [];
      } finally {
        this.exportLoading = false;
      }
    },
    formatExportRow(row, index) {
      const org = row.mzDrugOrg || {};
      const drug = org.mzDrug || {};
      const unit = org.isSeparate ? org.separateNumberUnit : org.specificationUnit;
      const drugTypes = { T: "(统)", X: "(选)", J: "(精选)" };
      const withUnit = (value, suffix, separator) =>
        value == null ? "" : `${value}${suffix ? separator + suffix : ""}`;
      const price = (value) => value == null ? "" : Number(value).toFixed(2);
      const date = (value) => value ? value.split("T")[0] : "";
      const text = (value) => String(value == null ? "" : value);
      return {
        编号: index + 1,
        药品名称: text((drug.drugName || "") + (drugTypes[drug.drugType] || "")),
        别名: text(drug.drugAlias),
        药品分类: text((drug.category || {}).categoryName),
        规格: text(withUnit(org.specification, org.specificationUnit, "/")),
        生产厂家: text(org.productFactory),
        批号: text(row.batchNumber),
        "进货价(元)": text(row.putInPrice == null ? "" : withUnit(price(row.putInPrice), org.specificationUnit, "/")),
        "售价(元)": text(row.tradingPrice == null ? "" : withUnit(price(row.tradingPrice), unit, "/")),
        入库数量: text(row.putInNumber == null ? "" : `${row.putInNumber}${unit ? `（${unit}）` : ""}`),
        剩余库存: text(row.inventoryNumber == null ? "" : `${row.inventoryNumber}${unit ? `（${unit}）` : ""}`),
        结存成本: row.putInPrice == null || row.inventoryNumber == null
          ? "" : Number((Number(row.putInPrice) * Number(row.inventoryNumber)).toFixed(2)),
        添加时间: this.$options.filters.timefilters(row.addTime),
        药品有效期: [date(row.productionDate), date(row.validDate)].filter(Boolean).join(" 至 "),
      };
    },
  },
};
</script>

<style scoped>
.inventory-card {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.inventory-page .table-top {
  flex-shrink: 0;
  margin-bottom: 12px;
}
.inventory-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 18px;
}
.inventory-filters ::v-deep .el-form-item {
  margin: 0;
}
.inventory-filters ::v-deep .el-form-item__label,
.inventory-filters ::v-deep .el-form-item__content {
  line-height: 32px;
}
.inventory-batch ::v-deep .el-input {
  width: 150px;
}
.inventory-keyword ::v-deep .el-input {
  width: 230px;
}
.inventory-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid #ebeef5;
}
.inventory-file-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}
.inventory-actions ::v-deep .el-button {
  margin: 0;
}
.inventory-import {
  display: inline-flex;
}
.inventory-table-wrap {
  flex: 1;
  min-height: 0;
}
.inventory-pagination {
  flex-shrink: 0;
  padding-top: 12px;
}
.dialog-form {
  width: 85%;
}
</style>
